export default {
    data() {
        return {
            errors: {}
        }
    },
    methods: {
        validateForm(fields, values, exceptions = []) {
            fields.forEach(field => {
                if (exceptions.includes(field.slug)) return
                if (field.hidden === true) return

                Object.keys(field.extra_parameters).forEach(function(key) {
                    field[key] = field.extra_parameters[key]
                })

                let value = values[field.slug]
                if (field.required && (!value || value.length === 0)) {
                    this.errors[field.slug] = 'Campo requerido'
                    return
                }

                if (field.max_length && value.length > field.max_length) {
                    this.errors[field.slug] = `Máximo de ${field.max_length} caracteres`
                    return
                }

                if (field.slug === 'phone' && !value.isValid) {
                    this.errors[field.slug] = 'Número de teléfono inválido'
                    return
                }

                let regex = null
                if(field.regex) {
                    regex = new RegExp(field.regex.replace(/\//g, ''))
                }

                if (field.regex && !regex.test(value)) {
                    this.errors[field.slug] = 'Campo inválido'
                    return
                }

                delete this.errors[field.slug]
            })

            this.$forceUpdate()
            return Object.keys(this.errors).length === 0
        },

    }
}